import { Customer, ShipTo } from '@next/core-lib/business-partner-aggregation-api';
import { Distance } from 'src/app/shared/models/distance.model';
import { ManureCategory } from 'src/app/shared/models/manure-category.model';
import { ManureType } from 'src/app/shared/models/manure-type.model';
import { Month } from 'src/app/shared/models/month.model';
import { PaymentType } from 'src/app/shared/models/payment-type.model';
import { Status } from 'src/app/shared/models/status.model';
import { TransportType } from 'src/app/shared/models/transport-type.model';

export interface ManureOffer {
  manureCategory: ManureCategory;
  manureType: ManureType;
  amountInTons: number;
  paymentType: PaymentType;
  pricePerTon: number;
  desiredDeliveryPeriodFrom?: Month;
  desiredDeliveryPeriodTo?: Month;
  nKgPerTon?: number;
  pKgPerTon?: number;
  kKgPerTon?: number;
  transportType?: TransportType;
  isHomogeneous?: boolean;
  customer?: Customer;
  shipTo?: ShipTo;
}

export interface ManureOfferForm {
  manureCategory: ManureCategory;
  manureType: ManureType;
  amountInTons: number;
  paymentType: PaymentType;
  pricePerTon: number;
  desiredDeliveryPeriodFrom?: Month;
  desiredDeliveryPeriodTo?: Month;
  nKgPerTon?: string;
  pKgPerTon?: string;
  kKgPerTon?: string;
  transportType?: TransportType;
  isHomogeneous?: boolean;
}

export interface ManureOfferModel extends ManureOffer {
  id: number;
  customerId?: number;
  status: Status;
  distance: Distance;
}

export interface OfferExportApiModel extends ManureOffer {
  id: number;
  createdAt: string;
  customer: Customer;
  shipTo: ShipTo;
  status: Status;
  maxNitrogen?: number;
  maxPhosphate?: number;
  totalPrice: number;
}

export interface OfferExportModel extends ManureOffer {
  createAt: Date;
  status: Status;
  maxNitrogen?: number;
  maxPhosphate?: number;
  totalPrice: number;
  customerName: string;
  customerEmailAddress: string;
  customerPhoneNumber: number;
  shipToName: string;
  shipToCity: string;
  shipToPostalCode: string;
  shipToStreet: string;
  shipToHouseNumber: string;
  shipToHouseNumberAddition: string;
  shipToCountry: string;
}

export const toOfferExportModel = (offer: OfferExportApiModel): OfferExportModel => ({
  createAt: new Date(offer.createdAt),
  manureCategory: offer.manureCategory,
  manureType: offer.manureType,
  amountInTons: offer.amountInTons,
  paymentType: offer.paymentType,
  pricePerTon: offer.pricePerTon,
  desiredDeliveryPeriodFrom: offer.desiredDeliveryPeriodFrom,
  desiredDeliveryPeriodTo: offer.desiredDeliveryPeriodTo,
  nKgPerTon: offer.nKgPerTon,
  pKgPerTon: offer.pKgPerTon,
  kKgPerTon: offer.kKgPerTon,
  transportType: offer.transportType,
  isHomogeneous: offer.isHomogeneous,
  status: offer.status,
  maxNitrogen: offer.maxNitrogen,
  maxPhosphate: offer.maxPhosphate,
  totalPrice: offer.totalPrice,
  customerName: offer.customer.name,
  customerEmailAddress: offer.customer.emailAddress,
  customerPhoneNumber: offer.customer.phoneNumber,
  shipToName: offer.shipTo.name,
  shipToCity: offer.shipTo.city,
  shipToPostalCode: offer.shipTo.postalCode,
  shipToStreet: offer.shipTo.street,
  shipToHouseNumber: offer.shipTo.houseNumber,
  shipToHouseNumberAddition: offer.shipTo.houseNumberAddition,
  shipToCountry: offer.shipTo.country,
});
